import CompletionCta from 'components/Project/CompletedProject/CompletionCta/CompletionCta'
import FooterContainer from 'components/shared/Footer/FooterContainer'
import PropTypes from 'prop-types'
import React from 'react'
import { v4 as uuidv4 } from 'uuid'

import './CompletedProject.scss'

const CompletedProject = ({ locale, projectSlug }) => {
  const userID = uuidv4()

  return (
    <React.Fragment>
      <main
        className="c-project__layout c-project__layout--project-complete u-clearfix"
        id="c-project__layout"
      >
        <section className="c-project__content c-project__content--project-complete">
          <div className="c-project-steps c-project-steps--project-complete">
            <CompletionCta locale={locale} projectSlug={projectSlug} />
          </div>
        </section>
      </main>

      <FooterContainer text="project.footer.feedback.text" userID={userID} />
    </React.Fragment>
  )
}

CompletedProject.propTypes = {
  locale: PropTypes.string.isRequired,
  projectSlug: PropTypes.string.isRequired,
}

export default CompletedProject
